import { Component, ElementRef, EventEmitter, input, Output } from '@angular/core';
import { PasswordHelpContent } from '../../interfaces/password-help-content.interface';
import { CommonModule } from '@angular/common';
import { HelpPopupComponent } from '../help-popup/help-popup.component';

@Component({
    selector: 'mono-common-password-help-popup',
    templateUrl: './password-help-popup.component.html',
    standalone: true,
    imports: [CommonModule, HelpPopupComponent]
})
export class PasswordHelpPopupComponent {

  public passwordHelp = input<PasswordHelpContent>({
    passwordHelpReveal: "Read password help",
    title: "Password help",
    passwordDescription: "Think of 3 memorable, unrelated words and add dashes:",
    passwordExample: "kettle-sunflower-road",
    dontUseExample: "(You can't use this example.)",
    selectShow: "Select 'show' to see your typing."
  });
  public inputAttachedTo = input.required<ElementRef>();
  public helpPopupCalledFrom = input<string | undefined>();
  public helpPopupPosition = input<'top' | 'bottom'>('top');
  public shadow = input<boolean>(false);

  @Output() helpPopupToggleEmit = new EventEmitter<boolean>();

  public helpPopupOpen = false;
  public temporaryHelpHTML = `<p>${this.passwordHelp().passwordDescription} </p><p class="indented">${this.passwordHelp().passwordExample}</p><p><b>${this.passwordHelp().dontUseExample}</b></p><p>${this.passwordHelp().selectShow}</p>`;

  public onOpenHelpPopup() {
    this.helpPopupOpen = true;
    this.helpPopupToggleEmit.emit(true);
  }

  public onCloseHelpPopup() {
    this.helpPopupOpen = false;
    this.helpPopupToggleEmit.emit(false);
  }

  public preventFocusOnElement(event: Event) {
    event.preventDefault();
  }

}